import styled from 'styled-components';
import color from '../utils/style/color';
import { fontWeight, fontSize } from '../utils/style/font';

const ButtonLabel = styled.span`
  height: 24px;
  font-size: ${fontSize.l}px;
  font-weight: ${fontWeight.xBold};
  color: ${color.gray.xxxxBright};
`;

export default ButtonLabel;
